import useGlobalStore from 'hooks/useGlobalStore';

import { TIME } from './constants';
import type { Notification } from './types';

export const useToast = () => {
    const { getValue, setValue } = useGlobalStore({
        namespace: 'useToast'
    });

    const toastData = () => getValue('toast');

    const setToastData = (value: Notification | null) => setValue({ toast: value });

    const broadcastToast = ({ text, time = TIME, type }: Notification & { time?: number }) => {
        setToastData({ text, type });
        setTimeout(() => setToastData(null), time);
    };

    return { broadcastToast, setToastData, toastData };
};

export default useToast;
